/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Grid_EmptyInputs */

const cs_builder_grid_empty = /** @type {(inputs: Builder_Grid_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné položky — přidejte řádek mřížky.`)
};

const en_builder_grid_empty = /** @type {(inputs: Builder_Grid_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No items — add a grid row.`)
};

/**
* | output |
* | --- |
* | "No items — add a grid row." |
*
* @param {Builder_Grid_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_grid_empty = /** @type {((inputs?: Builder_Grid_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Grid_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_grid_empty(inputs)
	return cs_builder_grid_empty(inputs)
});